import { Link } from '@tanstack/react-router';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { cn } from '@/lib/utils';
import { formatDisplayDate } from '@/utils/date';
import { formatTaka } from '@/utils/number';
import type { PcmpProposalTeacher } from '../../types/pcmpProposal.types';

interface PcmpTeacherLedgerTableProps {
  ledger: PcmpProposalTeacher['ledger'];
}

const NUMBER_CELL = 'text-right tabular-nums';

/** Every proposal for this teacher; the current one is highlighted. */
export function PcmpTeacherLedgerTable({ ledger }: PcmpTeacherLedgerTableProps) {
  return (
    <div className="overflow-x-auto">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Ref</TableHead>
            <TableHead>Date</TableHead>
            <TableHead className="text-right">Proposed</TableHead>
            <TableHead className="text-right">Disbursed</TableHead>
            <TableHead>Status</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {ledger.map((item) => (
            <TableRow
              key={item.proposalId}
              className={cn(item.isCurrent && 'bg-highlight/15 hover:bg-highlight/15')}
            >
              <TableCell className="font-medium">
                {item.isCurrent ? (
                  <span>
                    {item.refNo} <span className="text-xs text-muted-foreground">(this one)</span>
                  </span>
                ) : (
                  <Link
                    to="/pcmp/proposals/$proposalId"
                    params={{ proposalId: item.proposalId }}
                    className="text-primary underline-offset-4 hover:underline"
                  >
                    {item.refNo}
                  </Link>
                )}
              </TableCell>
              <TableCell>{formatDisplayDate(item.proposalDate)}</TableCell>
              <TableCell className={NUMBER_CELL}>{formatTaka(item.proposedAmount)}</TableCell>
              <TableCell className={NUMBER_CELL}>{formatTaka(item.paidAmount)}</TableCell>
              <TableCell>{item.status.label}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
